import React from "react";
import Tooltip from "components/Tooltip/Tooltip";

import ControlsButton from "components/ControlsButton";

const ControlsItem = ({ item, number, switchControlsView }) => {
  return (
    <React.Fragment>
      <div className="group-controls-col">
        <div className={`${item.classObject} col_${number}`}>
          {item.controls.map((btn, i) => (
            <ControlsButton key={i} btn={btn} />
          ))}
        </div>
        <div className="title" onClick={() => switchControlsView(number)}>
          <div>
            {item.title}
            {item.title === "Издания на иностранных языках" ? (
              <Tooltip explanation="На карте вы увидите библиотеки, в фонде которых не менее 100 изданий на английском языке и/или не менее 50 изданий на других иностранных языках." />
            ) : null}
          </div>
          <svg
            width="7"
            height="10"
            viewBox="0 0 7 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.5 10L0 8.5L3.5 5L0 1.5L1.5 0L6.5 5L1.5 10Z"
              fill="#808080"
            />
          </svg>
        </div>
      </div>
      <div className="group-controls-col--line" />
    </React.Fragment>
  );
};

export default ControlsItem;



// WEBPACK FOOTER //
// ./src/components/ControlsItem/index.js